/* NB-016-AB */
(function () {
  var ROOT_SEL = '[data-nb016-root]';
  var ACTIVATION_CLASS = 'nb016-ab-var-1';
  var JUMP_TEXT = 'jump to the #1 ranked mushroom';
  var moved = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findJumpLink() {
    var links = document.querySelectorAll('a[data-pf-type="Button2"], a');
    var i;
    var link;
    var text;

    for (i = 0; i < links.length; i += 1) {
      link = links[i];
      if (rootContains(link)) continue;
      text = normalizeText(link.textContent);
      if (text.indexOf(JUMP_TEXT) !== -1) {
        return link;
      }
    }

    return null;
  }

  function rootContains(node) {
    var root = document.querySelector(ROOT_SEL);
    return !!(root && node && root.contains(node));
  }

  function hideEmptyHost(host) {
    if (!host) {
      host = document.querySelector('.nb-016-comparison-tabs-section');
    }
    if (!host) return;
    if (host.querySelector('.__pf') || host.querySelector('[data-pf-type="Body"]')) {
      return;
    }
    if (!host.querySelector(ROOT_SEL)) {
      host.style.display = 'none';
    }
  }

  function unlockAncestors(root) {
    var node = root && root.parentElement;
    var hops = 0;
    while (node && hops < 10) {
      node.style.overflow = 'visible';
      node.style.maxHeight = 'none';
      node.style.height = 'auto';
      if (
        node.getAttribute('data-pf-type') === 'Section' ||
        node.classList.contains('shopify-section')
      ) {
        break;
      }
      node = node.parentElement;
      hops += 1;
    }
  }

  function waitForJump(cb, tries) {
    var left = typeof tries === 'number' ? tries : 50;
    var el = findJumpLink();
    if (el) {
      cb(el);
      return;
    }
    if (left <= 0) return;
    window.setTimeout(function () {
      waitForJump(cb, left - 1);
    }, 200);
  }

  function placeBeforeJump(root) {
    if (!root || moved) return;
    var anchor = findJumpLink();
    if (!anchor || !anchor.parentNode) return;
    var host = root.closest('.nb-016-comparison-tabs-section');
    if (root.parentNode === anchor.parentNode && root.nextElementSibling === anchor) {
      hideEmptyHost(host);
      unlockAncestors(root);
      moved = true;
      return;
    }
    anchor.parentNode.insertBefore(root, anchor);
    hideEmptyHost(host);
    unlockAncestors(root);
    moved = true;
  }

  function activateTab(root, index) {
    var tabs = root.querySelectorAll('[data-nb016-tab]');
    var panels = root.querySelectorAll('[data-nb016-panel]');
    var i;
    var tab;
    var panel;
    var isActive;

    for (i = 0; i < tabs.length; i += 1) {
      tab = tabs[i];
      isActive = String(tab.getAttribute('data-nb016-tab')) === String(index);
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    }

    for (i = 0; i < panels.length; i += 1) {
      panel = panels[i];
      isActive = String(panel.getAttribute('data-nb016-panel')) === String(index);
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      panel.removeAttribute('hidden');
    }
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function visibleOfferRow() {
    var rows = document.querySelectorAll('.pf-offer-row');
    var i;
    for (i = 0; i < rows.length; i += 1) {
      if (isVisible(rows[i])) return rows[i];
    }
    return null;
  }

  function resolveOfferTarget(href) {
    var row = visibleOfferRow();
    if (row) return row;

    var hash = String(href || '').split('#')[1] || '';
    var fromHref = hash ? document.getElementById(hash) : null;
    if (fromHref && isVisible(fromHref)) return fromHref;

    return document.getElementById('product-offer')
      || document.getElementById('product-offer-2')
      || fromHref
      || document.getElementById('target-section-2');
  }

  function headerOffset() {
    var extra = 56;
    var bottom = 0;
    var nodes = document.querySelectorAll(
      'sticky-header, .shopify-section-header-sticky, #shopify-section-header, .announcement-bar, #shopify-section-announcement-bar'
    );
    var i;
    var rect;
    for (i = 0; i < nodes.length; i += 1) {
      rect = nodes[i].getBoundingClientRect();
      if (rect.bottom > bottom && rect.top < 140) {
        bottom = rect.bottom;
      }
    }
    return Math.ceil(bottom) + extra;
  }

  function scrollToOffer(target) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduce ? 'auto' : 'smooth'
    });
  }

  function bindCtas(root) {
    root.addEventListener('click', function (event) {
      var cta = event.target.closest('.comparison-tabs__cta');
      if (!cta || !root.contains(cta)) return;

      var target = resolveOfferTarget(cta.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      scrollToOffer(target);
    });
  }

  function bindTabs(root) {
    var tabs = root.querySelectorAll('[data-nb016-tab]');
    if (!tabs.length) return;

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-nb016-tab]');
      if (!tab || !root.contains(tab)) return;
      activateTab(root, tab.getAttribute('data-nb016-tab'));
    });

    root.addEventListener('keydown', function (event) {
      var current = event.target.closest('[data-nb016-tab]');
      if (!current || !root.contains(current)) return;

      var list = Array.prototype.slice.call(tabs);
      var idx = list.indexOf(current);
      if (idx < 0) return;

      var nextIdx = idx;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIdx = (idx + 1) % list.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIdx = (idx - 1 + list.length) % list.length;
      } else if (event.key === 'Home') {
        nextIdx = 0;
      } else if (event.key === 'End') {
        nextIdx = list.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      list[nextIdx].focus();
      activateTab(root, list[nextIdx].getAttribute('data-nb016-tab'));
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-nb016-ready') === '1') return;
    root.setAttribute('data-nb016-ready', '1');
    bindTabs(root);
    bindCtas(root);
    placeBeforeJump(root);
  }

  function boot() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    initRoot(root);

    if (!moved) {
      waitForJump(function () {
        placeBeforeJump(root);
      });
    }

    if (document.documentElement.classList.contains(ACTIVATION_CLASS)) {
      placeBeforeJump(root);
    }
  }

  ready(boot);

  var observer = new MutationObserver(function () {
    if (!document.documentElement.classList.contains(ACTIVATION_CLASS)) return;
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    initRoot(root);
    placeBeforeJump(root);
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });
})();
